/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id   : 'example',
    //     title: 'Example',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/example'
    // }
    // ,
    {
        id   : 'gateway-metrics',
        title: 'Gateway Metrics',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/gateway-metrics'
    },
    {
        id: 'documentations',
        title: 'Documentations',
        subtitle: 'Guides and API documentations',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            // {
            //     id   : 'documentation-docs',
            //     title: 'Documentation', 
            //     type : 'basic',
            //     icon : 'heroicons_outline:document-text',
            //     link : '/documentations/documentation'
            // },
            {
                id   : 'documentation-docs',
                title: 'Documentation', 
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/documentations/api-guide'
            },
            {
                id   : 'swagger-ui',
                title: 'Swagger UI',
                type : 'basic',
                icon : 'heroicons_outline:arrows-right-left',
                link : '/documentations/swagger-ui'
            },
        ]
    },
    {
        id: 'authentication',
        title: 'Authentication',
        subtitle: 'Authentication, Authorization and API Key Management',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id   : 'clients',
                title: 'Clients', 
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/clients'
            },
            // {
            //     id   : 'meetering',
            //     title: 'Meetering',
            //     type : 'basic',
            //     icon : 'heroicons_outline:chart-pie',
            //     link : '/meetering'
            // },
        ]
    },

];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
